import { Country } from './country';
const mmDaf = {
    name: 'Mercy Mission UK',
    number: '1122922'
};
export const CompassionForCreation = {
    name: 'Compassion for Creation',
    number: '1204164'
};
export const charityDafPartnerDetails = new Map([
    [Country.GB, mmDaf],
    [Country.AU, {
            name: 'Myriad Australia Limited',
            number: 'ABN 20 640 318 636'
        }
    ],
    [Country.US, {
            name: 'Myriad USA',
            number: '58-2277856'
        }
    ],
    [Country.CA, {
            name: 'Myriad Canada',
            number: '76978 4893 RR0001'
        }
    ],
    [Country.CH, mmDaf],
    [Country.ID, {
            name: 'Kita Global Sbn Bhd',
            number: ''
        }
    ]
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGFmRGV0YWlscy5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJEYWZEZXRhaWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFbkMsTUFBTSxLQUFLLEdBQUc7SUFDWixJQUFJLEVBQUUsa0JBQWtCO0lBQ3hCLE1BQU0sRUFBRSxTQUFTO0NBQ2xCLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRztJQUNuQyxJQUFJLEVBQUUseUJBQXlCO0lBQy9CLE1BQU0sRUFBRSxTQUFTO0NBQ2xCLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSx3QkFBd0IsR0FBRyxJQUFJLEdBQUcsQ0FBNEM7SUFDekYsQ0FBQyxPQUFPLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQztJQUNuQixDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUU7WUFDWCxJQUFJLEVBQUUsMEJBQTBCO1lBQ2hDLE1BQU0sRUFBRSxvQkFBb0I7U0FDN0I7S0FDQTtJQUNELENBQUMsT0FBTyxDQUFDLEVBQUUsRUFBRTtZQUNYLElBQUksRUFBRSxZQUFZO1lBQ2xCLE1BQU0sRUFBRSxZQUFZO1NBQ3JCO0tBQ0E7SUFDRCxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUU7WUFDWCxJQUFJLEVBQUUsZUFBZTtZQUNyQixNQUFNLEVBQUUsbUJBQW1CO1NBQzVCO0tBQ0E7SUFDRCxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUUsS0FBSyxDQUFDO0lBQ25CLENBQUMsT0FBTyxDQUFDLEVBQUUsRUFBRTtZQUNYLElBQUksRUFBRSxxQkFBcUI7WUFDM0IsTUFBTSxFQUFFLEVBQUU7U0FDWDtLQUNBO0NBQ0YsQ0FBQyxDQUFBIn0=